import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) {
  return _pushScopeId("data-v-e65b98ee"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "check-box"
};
var _hoisted_2 = {
  class: "check-wrapper"
};
var _hoisted_3 = {
  class: "check-step"
};
var _hoisted_4 = {
  class: "check-step-box"
};
var _hoisted_5 = ["onClick"];
var _hoisted_6 = {
  class: "item-icon"
};
var _hoisted_7 = {
  key: 0,
  class: "step-status",
  width: "33",
  height: "33",
  viewBox: "0 0 33 33",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var _hoisted_8 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("circle", {
    cx: "16.5",
    cy: "16.5",
    r: "16.5",
    fill: "#FF5C00"
  }, null, -1);
});
var _hoisted_9 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M16.0401 8C14.9134 8 14 8.91338 14 10.0401V16.8404C14 17.9671 14.9134 18.8805 16.0401 18.8805C17.1668 18.8805 18.0802 17.9671 18.0802 16.8404V10.0401C18.0802 8.91338 17.1668 8 16.0401 8ZM16.0401 24.3209C17.1668 24.3209 18.0802 23.4076 18.0802 22.2808C18.0802 21.1541 17.1668 20.2408 16.0401 20.2408C14.9134 20.2408 14 21.1541 14 22.2808C14 23.4076 14.9134 24.3209 16.0401 24.3209Z",
    fill: "white"
  }, null, -1);
});
var _hoisted_10 = [_hoisted_8, _hoisted_9];
var _hoisted_11 = {
  key: 1,
  class: "step-status",
  width: "33",
  height: "33",
  viewBox: "0 0 33 33",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var _hoisted_12 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("circle", {
    cx: "16.5",
    cy: "16.5",
    r: "16.5",
    fill: "#FF5C00"
  }, null, -1);
});
var _hoisted_13 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("path", {
    d: "M9.40265 16.6355L13.839 20.8491L21.6815 13.2862",
    stroke: "white",
    "stroke-width": "3",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, null, -1);
});
var _hoisted_14 = [_hoisted_12, _hoisted_13];
var _hoisted_15 = {
  key: 2,
  class: "step-order"
};
var _hoisted_16 = {
  class: "item-title"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("ul", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.steps, function (item, index) {
    return _openBlock(), _createElementBlock("li", {
      class: _normalizeClass(["step-item", [item.status ? 'step-item-' + item.status : '', _ctx.currentStepIndex === index ? 'step-item-active' : '']]),
      key: index,
      onClick: function ($event) {
        return _ctx.handleStep(index);
      }
    }, [_createElementVNode("div", {
      class: "item-tail",
      onClick: _cache[0] || (_cache[0] = _withModifiers(function () {}, ["stop"]))
    }), _createElementVNode("div", _hoisted_6, [item.status === 'error' ? (_openBlock(), _createElementBlock("svg", _hoisted_7, _hoisted_10)) : item.status === 'finish' ? (_openBlock(), _createElementBlock("svg", _hoisted_11, _hoisted_14)) : (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(index + 1), 1))]), _createElementVNode("div", _hoisted_16, _toDisplayString(item.label), 1)], 10, _hoisted_5);
  }), 128))])]), (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.currentStepItem.comName)))])]);
}